// General strings
import LangShare from "./general/LangShare"
import LangErrorMessage from "./general/LangErrorMessage"

// Modules string
import LangHeader from "./modules/LangHeader"
import LangSidebar from "./modules/LangSidebar"
import LangFooter from "./modules/LangFooter"
import LangMyAccount from "./modules/LangMyAccount"
import LangMyRewards from "./modules/LangMyRewards"
import LangMyTransactions from "./modules/LangMyTransactions"
import LangDefaultCardForm from "./modules/LangDefaultCardForm"
import LangIdleMonitor from "./modules/LangIdleMonitor"
import LangEgiftFooter from "./modules/LangEgiftFooter"
import LangEgiftHeader from "./modules/LangEgiftHeader"
import LangEgiftPurchaseHistory from "./modules/LangEgiftPurchaseHistory"
import LangEgiftPurchaseDetail from "./modules/LangEgiftPurchaseDetail"

// Pages strings
import LangSignIn from "./pages/LangSignIn"
import LangSignUp from "./pages/LangSignUp"
import LangForgotEmail from "./pages/LangForgotEmail"
import LangForgotPassword from "./pages/LangForgotPassword"
import LangResetPassword from "./pages/LangResetPassword"
import LangContactUs from "./pages/LangContactUs"
import LangChangePassword from "./pages/LangChangePassword"
import LangProfile from "./pages/LangProfile"
import LangUnregister from "./pages/LangUnregister"
import LangCardDetails from "./pages/LangCardDetails"
import LangCards from "./pages/LangCards"
import LangTransactionDetails from "./pages/LangTransactionDetails"
import LangAddCard from "./pages/LangAddCard"
import LangNotFound from "./pages/LangNotFound"
import LangTransferBalance from "./pages/LangTransferBalance"
import LangReportLostCard from "./pages/LangReportLostCard"
import LangModal from "./modules/LangModal"
import LangVerifyGoldCardAddress from "./pages/LangVerifyGoldCardAddress"
import LangLandingPage from "./pages/LangLandingPage"
import LangCardReload from "./pages/LangCardReload"
import LangEgiftCardCheckout from "./pages/LangEgiftCardCheckout"
import LangEgiftShoppingCart from "./pages/LangEgiftShoppingCart"
import LangEgiftShoppingCartSuccess from "./pages/LangEgiftShoppingCartSuccess"
import LangEgiftCard from "./pages/LangEgiftCard"
import LangEgiftCardDetails from "./pages/LangEgiftCardDetails"
import LangEgiftCardVerifyEgift from "./pages/LangEgiftCardVerifyEgift"
import LangEgiftCardRedemption from "./pages/LangEgiftCardRedemption"
import LangEgift from "./pages/LangEgift"
import LangTermNConditionPopup from "./pages/LangTermNConditionPopup"
import LangEgiftHeaderMegaMenuLink from "./modules/LangEgiftHeaderMegaMenuLink"
import LangEgiftHeaderMegaMenu from "./modules/LangEgiftHeaderMegaMenu"

var Translations = {}

// General strings
Translations = Object.assign(Translations, LangShare, LangErrorMessage)

// Modules strings
Translations = Object.assign(
	Translations,
	LangMyAccount,
	LangMyRewards,
	LangMyTransactions,
	LangDefaultCardForm,
	LangHeader,
	LangFooter,
	LangSidebar,
	LangIdleMonitor,
	LangModal,
	LangEgiftHeader,
	LangEgiftFooter,
	LangEgiftPurchaseHistory,
	LangEgiftPurchaseDetail
)

// Pages strings
Translations = Object.assign(
	Translations,
	LangSignIn,
	LangSignUp,
	LangForgotEmail,
	LangForgotPassword,
	LangContactUs,
	LangChangePassword,
	LangUnregister,
	LangProfile,
	LangCardDetails,
	LangCards,
	LangResetPassword,
	LangTransactionDetails,
	LangAddCard,
	LangNotFound,
	LangTransferBalance,
	LangReportLostCard,
	LangVerifyGoldCardAddress,
	LangLandingPage,
	LangCardReload,
	LangEgiftCardCheckout,
	LangEgiftShoppingCart,
	LangEgiftShoppingCartSuccess,
	LangEgiftCard,
	LangEgiftCardDetails,
	LangEgiftCardVerifyEgift,
	LangEgiftCardRedemption,
	LangEgift,
	LangTermNConditionPopup,
	LangEgiftHeaderMegaMenu,
	LangEgiftHeaderMegaMenuLink
)

export default Translations



// WEBPACK FOOTER //
// ./src/resources/Translations.js